// extracted by mini-css-extract-plugin
export default {"loaderContainer":"api-info_loaderContainer__AetAE","errorContainer":"api-info_errorContainer__lYNwH"};